<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>assignment</md-icon>
          </div>
          <h4 class="title">Dorm Users</h4>
          <div class="md-card-header-icon md-card-header-green text-right">
            <md-button @click="goToCreate" class="md-success"
              >CREATE DORM USER</md-button
            >
          </div>
        </md-card-header>
        <md-card-content>
          <md-table
            :value="queriedData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
            class="paginated-table table-striped table-hover"
          >
            <md-table-toolbar>
              <md-field>
                <label for="pages">Per page</label>
                <md-select
                  v-model="pagination.perPage"
                  name="pages"
                  @md-selected="customSort"
                >
                  <md-option
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                    {{ item }}
                  </md-option>
                </md-select>
              </md-field>

              <div>
                <md-button
                  style="margin-left: 10px"
                  @click="filterPanel"
                  class="md-info"
                >
                  Filters
                </md-button>
                <md-button
                  style="margin-left: 10px"
                  @click="clearFilters"
                  class="md-primary md-just-icon md-round"
                >
                  <md-icon>delete_sweep</md-icon>
                  <md-tooltip md-direction="bottom">Clear Filters</md-tooltip>
                </md-button>
              </div>
            </md-table-toolbar>

            <md-table-empty-state
              v-show="!table_spinner"
              md-label="No users found"
              :md-description="`No users found for student.`"
            >
            </md-table-empty-state>

            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Full Name" md-sort-by="full_name">
                {{ item.first_name }} {{ item.last_name }}
              </md-table-cell>
              <md-table-cell md-label="Title" md-sort-by="title">
                {{ item.title }}
              </md-table-cell>
              <md-table-cell md-label="Email" md-sort-by="email"
                >{{ item.email }}
              </md-table-cell>
              <md-table-cell md-label="Gender">{{ item.gender }}</md-table-cell>
              <md-table-cell v-if="item.mobile_phone" md-label="Phone">
                {{ item.mobile_phone }}
              </md-table-cell>
              <md-table-cell v-else md-label="Phone">-</md-table-cell>
              <md-table-cell v-if="item.country" md-label="Country"
                >{{ item.country.name }}
              </md-table-cell>
              <md-table-cell v-else md-label="Country">-</md-table-cell>
              <md-table-cell v-if="item.is_active == true" md-label="Status"
                >Active
              </md-table-cell>
              <md-table-cell v-else md-label="Status">Inactive</md-table-cell>
              <md-table-cell md-label="Date Joined">{{
                item.date_joined
              }}</md-table-cell>
              <md-table-cell md-label="Actions">
                <md-button
                  style="margin-right: 30px;"
                  class="md-just-icon md-warning md-round"
                  @click.native="handleEdit(item)"
                >
                  <md-icon>create</md-icon>
                  <md-tooltip md-direction="bottom">Edit</md-tooltip>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
          <div class="footer-table md-table">
            <table>
              <tfoot>
                <tr>
                  <th
                    v-for="item in footerTable"
                    :key="item.name"
                    class="md-table-head"
                  >
                    <div class="md-table-head-container md-ripple md-disabled">
                      <div class="md-table-head-label">
                        {{ item }}
                      </div>
                    </div>
                  </th>
                </tr>
              </tfoot>
            </table>
          </div>
        </md-card-content>
        <md-card-content class="md-size-50 mx-auto" v-if="table_spinner">
          <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <div class="">
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
            @page="updatePage"
          >
          </pagination>
        </md-card-actions>
      </md-card>
      <md-dialog :md-active.sync="showFilters" class="filterPanelClass">
        <md-dialog-title>Filters</md-dialog-title>
        <div class="md-layout-item md-size-100 md-small-size-100">
          <md-field>
            <md-icon>account_balance</md-icon>
            <label>First Name</label>
            <md-input v-model="first_name" type="text"></md-input>
          </md-field>
        </div>

        <div class="md-layout-item md-size-100 md-small-size-100">
          <md-field>
            <md-icon>account_balance</md-icon>
            <label>Last Name</label>
            <md-input v-model="last_name" type="text"></md-input>
          </md-field>
        </div>

        <div class="md-layout-item md-size-100 md-small-size-100">
          <md-field>
            <md-icon>account_balance</md-icon>
            <label>Email</label>
            <md-input v-model="email" type="text"></md-input>
          </md-field>
        </div>

        <md-dialog-actions>
          <md-button class="md-danger" @click="showFilters = false"
            >Close</md-button
          >
          <md-button class="md-success" @click="addFilter">Filter</md-button>
        </md-dialog-actions>
      </md-dialog>
    </div>
  </div>
</template>

<script>
import { Pagination } from "@/components";
import Swal from "sweetalert2";

export default {
  components: {
    Pagination
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      return this.tableData;
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.pagination.total;
    },
    getParams() {
      return {
        ordering: this.getSortingKey(),
        limit: this.pagination.perPage,
        offset: this.from,
        ...this.searchQuery
      };
    }
  },
  data() {
    return {
      currentSort: "id",
      currentSortOrder: "desc",
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [10, 20, 30],
        total: 0
      },
      footerTable: [
        "Full Name",
        "Title",
        "Email",
        "Gender",
        "Phone",
        "Country",
        "Activate",
        "Date Joined",
        "Actions"
      ],
      searchQuery: {},
      propsToSearch: ["id", "first_name", "last_name", "email"],
      tableData: [],
      searchedData: [],
      first: true,

      table_spinner: true,
      showFilters: false,

      first_name: null,
      last_name: null,
      email: null
    };
  },
  methods: {
    goToCreate: function() {
      this.$router.push({ name: "Dorm User Create" });
    },
    filterPanel: function() {
      this.showFilters = true;
    },
    clearFilters: function() {
      this.searchQuery = {};
      this.first_name = null;
      this.last_name = null;
      this.email = null;
      this.pagination.currentPage = 1;
      this.getUsers();
    },
    addFilter: function() {
      let origin_params = {};
      var params = {
        first_name: this.first_name,
        last_name: this.last_name,
        email: this.email
      };
      for (const field in params) {
        if (
          params[field] === null ||
          params[field] === undefined ||
          params[field] === ""
        ) {
          continue;
        }
        origin_params[field] = params[field];
      }
      this.searchQuery = origin_params;
      this.pagination.currentPage = 1;
      this.getUsers();
      this.showFilters = false;
    },
    customSort(value) {
      if (this.first) {
        this.first = false;
        this.checkQueryParam();
      } else {
        this.pagination.currentPage = 1;
      }
      this.getUsers();
    },
    getSortingKey() {
      var key = this.currentSort;
      if (this.currentSortOrder === "desc") {
        key = "-" + this.currentSort;
      }
      return key;
    },
    handleEdit(item) {
      this.$router.push({ name: "Dorm User Update", params: { id: item.id } });
    },
    handleDelete(item) {
      Swal.fire({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.deleteRow(item);
          Swal.fire({
            title: "Deleted!",
            text: `You deleted ${item.name}`,
            type: "success",
            confirmButtonClass: "md-button md-success btn-fill",
            buttonsStyling: false
          });
        }
      });
    },
    deleteRow(item) {
      let indexToDelete = this.tableData.findIndex(
        tableRow => tableRow.id === item.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
    getUsers() {
      this.tableData = [];
      this.table_spinner = true;
      var params = this.getParams;
      // get dorm users
      let role = 5;
      this.$store
        .getUsers(role, params)
        .then(response => {
          this.tableData = response.data.results;
          this.pagination.total = response.data.count;
          if (params.offset) {
            this.pagination.currentPage = this.getCurrentPage(params.offset);
          }
          this.table_spinner = false;
        })
        .catch(error => {
          this.table_spinner = false;
          this.$notify({
            message: JSON.stringify(error.response.data),
            icon: "add_alert",
            type: "warning",
            verticalAlign: "top"
          });
        });
    },
    updatePage(page) {
      this.getUsers();
    },
    getCurrentPage(offset) {
      return offset / this.pagination.perPage + 1;
    },
    checkQueryParam() {
      if (window.location.search !== "") {
        var params = window.location.search
          .slice(1)
          .split("&")
          .map(p => p.split("="))
          .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
        if (params.ordering) {
          if (params.ordering[0] === "-") {
            this.currentSortOrder = "desc";
            params.ordering = params.ordering.replace("-", "");
          } else {
            this.currentSortOrder = "asc";
          }
          this.currentSort = params.ordering;
          delete params.ordering;
        }
        if (params.limit) {
          this.pagination.perPage = parseInt(params.limit);
          delete params.limit;
        }
        if (params.offset) {
          this.pagination.currentPage = this.getCurrentPage(params.offset);
          delete params.offset;
        }
        this.searchQuery = params;
      }
    }
  },
  watch: {
    searchQuery(query) {
      let params = this.getParams;
      let query_param = Object.keys(params)
        .map(key => key + "=" + params[key])
        .join("&");
      window.history.replaceState(
        "page",
        "Title",
        window.location.pathname + "?" + query_param
      );
    },
    pagination: {
      deep: true,
      handler(val) {
        let params = this.getParams;
        let query_param = Object.keys(params)
          .map(key => key + "=" + params[key])
          .join("&");
        window.history.replaceState(
          "page",
          "Title",
          window.location.pathname + "?" + query_param
        );
      }
    }
  }
};
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
</style>
